import React from "react";
import styled from "styled-components";

import UIInput from "components/UI/Input";
import UILabel from "components/UI/Label";
import UIButtonPrimary from "components/UI/Button/Primary";
import UIPrimaryWidgetBox from "components/UI/PrimaryWidgetBox";
import UISearchDropdown from "components/UI/SearchDropdown";
import commonStyles from "css/common.module.css";

const Container = styled.div.attrs({ className: "change-role" })`
  & .row {
    margin: 0 0 24px;
    width: 100%;
    text-align: center;
  }
  & .control {
    display: inline-block;
    text-align: left;
  }
  & .btn-container {
    display: inline-block;
    text-align: center;
  }
  & .change-role-btn {
    height: 36px;
    font-weight: bold;
    padding: 6px 34px;
    width: 150px;
  }
  & .title {
    font-size: 19px;
    font-weight: bold;
    margin: 0 0 24px;
  }
  & .required-field {
    font-size: 12px;
    vertical-align: text-top;
    margin-left: 2px;
    color: #194fa1;
  }
`;

class ChangeRoleView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: ""
    };
  }

  componentDidMount() {
    this.props.fetchData();
  }

  onSelectedCompany(e){
    this.setState({
      companyId: e.value
    });
  }

  onSubmit(e) {
    e.preventDefault();
    this.props.changeRole(this.state.companyId);
  }

  onResetRole(e){
    this.props.resetRole();
  }

  render (){
    return (
      <Container
        style={{backgroundColor:'#EDEDED'}}
        className={`${commonStyles.page} ${commonStyles.padded} ${commonStyles.clear }`}
      >
        <UIPrimaryWidgetBox className="p" style={{height:'100%'}}>
          <form id="changeRole" onSubmit={this.onSubmit.bind(this)}>
            <div className="title">Change Role</div>
            <div className="row">
              <div className="control">
                <UILabel>Select Company</UILabel>
                <UISearchDropdown
                  onSelection={this.onSelectedCompany.bind(this)}
                  placeholder="Select"
                  items={this.props.companies}
                  containerProps={{ className: "states-dropdown" }}
                  data-change-role-dropdown
                  id="change_role"
                />
              </div>
            </div>
            <div className="row">
              <div className="btn-container">
                <UIButtonPrimary
                  className="change-role-btn"
                  type="submit">
                  Change Role
                </UIButtonPrimary>
              </div>
            </div>
            {
              this.props.isGhosting && <div className="row">
                <div className="btn-container">
                  <UIButtonPrimary
                    className="change-role-btn"
                    onClick={this.onResetRole.bind(this)}
                    type="button" style={{}}>
                    Reset Role
                  </UIButtonPrimary>
                </div>
              </div>
            }
          </form>
        </UIPrimaryWidgetBox>
      </Container>
    );
  }
}

export default ChangeRoleView;
